import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import "../../css/Manage.css";
import RoomApi from "../../api/roomApi";
import { toast } from "react-toastify";
import ReservationApi from "../../api/reservationApi";
// import "../../css/space/Reservation.css";

const ManageReservation = () => {
  const navigate = useNavigate();
  const { residencyId } = useParams();

  const [roomOptions, setRoomOptions] = useState();
  const [selectedRoom, setSelectedRoom] = useState();
  const [openMenu, setOpenMenu] = useState(false);
  const [orderNumber, setOrderNumber] = useState("");
  const [notice, setNotice] = useState("");

  const handleSubmit = async () => {
    if (!selectedRoom?.value) return toast("숙소를 선택해주세요");
    if (!orderNumber) return toast("주문번호를 입력해주세요");

    ReservationApi.Post({
      residencyId,
      roomId: selectedRoom?.value,
      orderNumber,
      notice,
    })
      .then(() => {
        toast("숙소지정이 완료되었습니다");
        navigate(-1);
      })
      .catch(() => toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요."));
  };

  useEffect(() => {
    RoomApi.Get()
      .then((res) => {
        const options = res.data.data.content.map((v) => ({
          label: v.name,
          value: v.id,
        }));
        setRoomOptions(options);
      })
      .catch(() => toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요."));
  }, []);

  return (
    <div className="Manage-container">
      <section className="Manage-contents">
        <div className="go-back-container-space-adit">
          <div
            className="go-back"
            onClick={() => {
              navigate(-1);
            }}
          >
            <Link>
              <img src="\img\chevron-left.svg" />
              <span>뒤로가기</span>
            </Link>
          </div>
        </div>
        <div className="Manage-form manage-form-space-adit">
          <span>숙소지정하기</span>
          <div style={{ paddingBottom: 60 }}>
            <div className="Manage-input-container Manage-input-container-space-adit">
              <p className="Manage-input-title">숙소*</p>
              <div className="select">
                <div
                  className="selected"
                  onClick={() => setOpenMenu((v) => !v)}
                >
                  <div className="selected-value">{selectedRoom?.label}</div>
                  <div className="select-toggle-btn">
                    <img src="\img\table-togle.svg" />
                  </div>
                </div>
                {openMenu ? (
                  <ul className="option-container">
                    {roomOptions?.map((v) => {
                      return (
                        <li
                          key={v.value}
                          className="option"
                          onClick={() => {
                            setSelectedRoom({ label: v.label, value: v.value });
                            setOpenMenu(false);
                          }}
                        >
                          {v.label}
                        </li>
                      );
                    })}
                  </ul>
                ) : null}
              </div>
            </div>

            <div className="Manage-input-container Manage-input-container-space-add">
              <span className="Manage-input-title">주문번호*</span>
              <input
                className="Manage-input-textarea manage-form-space-add-input"
                type="text"
                placeholder="주문번호를 입력해주세요"
                value={orderNumber}
                onChange={(e) => setOrderNumber(e.target.value)}
              />
            </div>
            <div className="Manage-input-container Manage-input-container-space-add">
              <span className="Manage-input-title">중요 안내</span>
              <textarea
                placeholder="중요 안내를 입력해주세요"
                value={notice}
                onChange={(e) => setNotice(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div className="Manage-form-save manage-form-save-space-adit">
            <button
              type="button"
              className="cursorPointer"
              onClick={handleSubmit}
            >
              완료
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManageReservation;
